/* ============================================================================
   BRAVORA — Localizador de enlaces (todos los idiomas)
   Problema: muchos CTAs/botones se introdujeron en el admin como URL ABSOLUTA
   (https://www.bravorajewelry.com/pages/...) o ruta raiz (/collections/...).
   Shopify NO les añade el prefijo de idioma -> en /de /fr /it el cliente acaba
   en la pagina ES. Esto reescribe cualquier enlace interno que NO lleve ya un
   prefijo de idioma para que apunte al idioma actual. Solo actua fuera del
   idioma primario (es). Respeta el selector de idioma y los enlaces ya
   localizados (no doble-prefija). Defensivo: si algo no encaja, no-op.
   ============================================================================ */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (root === '/') return; // idioma primario (es): nada que hacer
  var rootNoSlash = root.replace(/\/+$/, ''); // '/de'

  // Idiomas publicados: no tocar enlaces que ya apuntan a ESTOS prefijos
  // (incluye el selector de idioma, que apunta a otros locales a proposito).
  var LOCALE_PFX = /^\/(en|de|fr|it)(\/|$|\?|#)/i;
  var SKIP_PATH = /^\/(cdn|apps|\.well-known|wpm@|services)\//i;

  function pathOf(href) {
    var m = href.match(/^https?:\/\/(?:www\.)?bravorajewelry\.com(\/.*)?$/i);
    if (m) return m[1] || '/';
    if (href.charAt(0) === '/') return href; // ruta raiz
    return null; // externo / relativo-otro / mailto / tel / # ...
  }

  function fix(a) {
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
    var path = pathOf(href);
    if (path === null) return;
    if (SKIP_PATH.test(path)) return;
    if (LOCALE_PFX.test(path)) {
      // ya localizado (este idioma u otro). Si venia con dominio absoluto, lo
      // dejamos como ruta para consistencia, sin cambiar el idioma.
      if (/^https?:/i.test(href)) a.setAttribute('href', path);
      return;
    }
    a.setAttribute('href', rootNoSlash + path);
  }

  function run(scope) {
    var as = (scope || document).querySelectorAll('a[href]');
    for (var i = 0; i < as.length; i++) fix(as[i]);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', function () { run(); });

  // Secciones que se recargan en el editor / contenido que llega por JS.
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  try {
    var pend = false;
    var mo = new MutationObserver(function () {
      if (pend) return; pend = true;
      window.requestAnimationFrame(function () { pend = false; run(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();

/* B15-F4 cookie preferences: corrige el href inyectado sin navegar a /policies/. */
(() => {
  const badHash = '#shopifyReshowConsentBanner';
  const fixCookieLinks = (root = document) => {
    root.querySelectorAll?.('a[href]').forEach((link) => {
      let url;
      try {
        url = new URL(link.getAttribute('href'), window.location.href);
      } catch (_) {
        return;
      }
      if (url.hash === badHash && /^\/policies\/?$/.test(url.pathname)) {
        link.setAttribute('href', badHash);
      }
    });
  };
  const start = () => {
    fixCookieLinks();
    new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) fixCookieLinks(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* B15-F4b prefs opener: abrir preferencias de consentimiento al clicar el link. */
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest("a[href$='#shopifyReshowConsentBanner']");
    if (!link) return;
    event.preventDefault();
    const pb = window.privacyBanner;
    if (pb && typeof pb.showPreferences === 'function') { pb.showPreferences(); return; }
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.showPreferences === 'function') { cp.showPreferences(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => { const c = window.Shopify.customerPrivacy; c && c.showPreferences && c.showPreferences(); }
      );
    }
  });
})();
